import React, { useEffect } from 'react';
import moment from 'moment-timezone';
import { withProviders } from './withProviders';
import { Routes } from '@processes/Routes';
import '@shared/styles';
import { useWebSocketUpdate } from './WebSockets/web-socket';

moment.tz.setDefault('America/New_York');

const AppComponent = () => {
    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');
    useWebSocketUpdate(userObject?.id, userObject?.email);

    return <Routes />;
};

export const App = withProviders(AppComponent);
